"use client";
import { useEffect } from "react";
import { Button } from "antd";
import useChatNow from "app/models/hooks/useChatNow";
import { useSearchParams } from "next/navigation";

const Chat = (props) => {
  const searchParams = useSearchParams();
  const { jobId, data, className, chat_button } = props;
  console.log({ data }, 566666);
  const source = searchParams.get("source");
  const chat = {
    chat_id: chat_button?.chat_id,
    is_exists: chat_button?.is_exists,
    job_application_id: chat_button?.job_application_id,
    job_id: chat_button?.job_id,
    job_identity_restrictions: data?.identity_restrictions
  };
  const jobDetail = {
    chat,
    id: jobId,
    is_resume_required: data?.is_resume_required,
    job_identity_restrictions: data?.identity_restrictions
  };

  const [loading, chatNow, changeJobModal, userData] = useChatNow(
    jobDetail,
    source ?? "job_details"
  );

  useEffect(() => {
    document.addEventListener("scroll", handleAddHeadBoxShadow);
    return () => document.removeEventListener("scroll", handleAddHeadBoxShadow);
  }, []);

  const handleAddHeadBoxShadow = () => {
    const scrollTopHeight = document.body.scrollTop || document.documentElement.scrollTop;
    const headNode = document.querySelector("#jobDetaiPagelHead");
    if (!headNode) return;
    if (scrollTopHeight > 55) {
      (headNode as HTMLElement).style.boxShadow = "10px 5px 5px rgba(217,217,217, 0.6)";
    } else {
      (headNode as HTMLElement).style.boxShadow = "unset";
    }
  };
  const handleBtnEvent = () => {
    (chatNow as any)?.(jobDetail);
  };

  const handleGetChatNowElement = () => {
    return (
      <Button
        loading={loading as boolean}
        type='primary'
        className={className}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleBtnEvent();
        }}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='18'
          height='19'
          viewBox='0 0 18 19'
          fill='none'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16.7175 6.07641C16.3469 5.02264 15.7826 4.11802 15.0407 3.38755C14.3052 2.66415 13.3997 2.11549 12.3486 1.75718C11.361 1.42063 10.2343 1.25 9.00015 1.25C7.76604 1.25 6.63636 1.42651 5.64319 1.77041C4.5953 2.13462 3.69186 2.68916 2.95639 3.41844C2.22093 4.14773 1.65403 5.05529 1.28336 6.10407C0.929453 7.10665 0.75 8.24897 0.75 9.50015C0.75 10.7651 0.931513 11.9186 1.28954 12.9262C1.66315 13.9779 2.23093 14.882 2.97552 15.6124C3.71098 16.3347 4.61678 16.8827 5.66555 17.2416C6.65196 17.5788 7.77398 17.75 9.00015 17.75C12.7528 17.75 15.1848 15.9593 15.1848 15.9593L16.4422 16.783C16.4422 16.783 17.25 13.3519 17.25 9.50074C17.25 8.23309 17.0708 7.08135 16.7175 6.07641ZM13.6901 14.0765C13.6295 14.0394 12.8766 13.5426 12.8766 13.5426C11.6411 14.2624 10.4675 14.574 9.00015 14.574C7.30976 14.574 6.03093 14.1621 5.19927 13.3452C4.35466 12.5173 3.92721 11.2229 3.92721 9.50015C3.92721 7.79387 4.35319 6.5071 5.19221 5.67367C6.02711 4.84583 7.30799 4.42632 9.00015 4.42632C10.7038 4.42721 11.9879 4.83907 12.8116 5.65131C13.6486 6.47503 14.0657 7.77181 14.1128 9.50015C14.1649 11.3544 13.891 13.0013 13.6901 14.0765ZM6.90276 7.40637C6.78709 7.40633 6.67253 7.42909 6.56565 7.47334C6.45877 7.51759 6.36166 7.58247 6.27986 7.66426C6.19807 7.74606 6.13319 7.84317 6.08894 7.95005C6.04469 8.05693 6.02193 8.17149 6.02197 8.28716V8.9126C6.02193 9.0283 6.04469 9.14286 6.08893 9.24976C6.13318 9.35666 6.19805 9.45379 6.27985 9.53561C6.36164 9.61743 6.45875 9.68233 6.56563 9.72661C6.67251 9.7709 6.78707 9.79369 6.90276 9.79369C7.13627 9.79322 7.36008 9.70024 7.52517 9.53509C7.69026 9.36995 7.78317 9.14611 7.78356 8.9126V8.28716C7.78356 8.05356 7.69076 7.82953 7.52558 7.66435C7.3604 7.49917 7.13637 7.40637 6.90276 7.40637ZM10.4738 7.66435C10.639 7.49917 10.863 7.40637 11.0966 7.40637C11.2123 7.40633 11.3268 7.42909 11.4337 7.47334C11.5406 7.51759 11.6377 7.58247 11.7195 7.66426C11.8013 7.74606 11.8662 7.84317 11.9104 7.95005C11.9547 8.05693 11.9774 8.17149 11.9774 8.28716V8.9126C11.9774 9.0283 11.9547 9.14286 11.9104 9.24976C11.8662 9.35666 11.8013 9.45379 11.7195 9.53561C11.6377 9.61743 11.5406 9.68233 11.4337 9.72661C11.3269 9.7709 11.2123 9.79369 11.0966 9.79369C10.8631 9.79322 10.6393 9.70024 10.4742 9.53509C10.3091 9.36995 10.2162 9.14611 10.2158 8.9126V8.28716C10.2158 8.05356 10.3086 7.82953 10.4738 7.66435Z'
            fill='white'
          />
        </svg>
        {chat_button?.is_exists ? chat_button?.continue_text : chat_button?.text}
      </Button>
    );
  };
  if (chat_button) {
    return (
      <div>
        {handleGetChatNowElement()}
        {changeJobModal}
      </div>
    );
  }

  return null;
};

export default Chat;
